module.exports = __webpack_public_path__ + "media/images/webpage/coupons/ogp-aec8a1cbe615879146f47d60e82e4a6b.webp";